import React from 'react';
import './index.scss';
import SpConfOdItem from '../../molecules/SpConfOdItem';

const SpConfTitle = ({
    text,
    list = [],
    icon,
    comment
}) => {
    const ShowList = ({ list: detail }) => {
        return (
            <div className="">
                {detail.map(data => (
                    <span className="" key={data.text}>
                        <SpConfOdItem
                            text={data.text}
                            children={data.children}
                            modify={data.modify}
                            modifyLinks={data.modifyLinks} />
                    </span>
                )
                )}
            </div>
        )
    };

    return (
        <div className="SpConfTitle">
            <div className="SITM-title">
                <div className="SITM-titleArea">
                    <p className="title"> {text} </p>
                </div>
            </div>
            <div className="SITM-item">
                <ShowList list={list} />
            </div>
            <div className="commentArea">
                {comment}
            </div>
            <div className="horizontalLine"></div>
        </div>
    );
};

export default SpConfTitle;